export default __webpack_public_path__ + "static/media/night.4f2211f7.jpg";